import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { JsonHalCollection } from "src/app/models/api/jsonhal.model";
import { InLineControlModel } from "src/app/models/api/inLineControl.model";
import { HttpService } from "../http/http.service";
import { InLineControlRulesViewModel } from "src/app/models/viewModels/InLineControlRulesViewModel";

@Injectable({
    providedIn: "root",
})
export class PoliciesInLineControlRulesHttpService {
    public readonly defaultPageSize: number = 50;
    private _httpService: HttpService;

    constructor(private _http: HttpClient) {
        this._httpService = new HttpService(this._http);
    }

    public getInLineControlRules(): Observable<InLineControlRulesViewModel[]> {
        return this._http.get<InLineControlRulesViewModel[]>("assets/mockData/inLineControlRulesMockData.json");
    }

    public getInLineControlsByContinuationToken(continuationToken: string): Observable<JsonHalCollection<InLineControlModel>> {
        const url = "detection/in-line-controls-pages";
        const httpParams = new HttpParams().append("continuationToken", continuationToken);
        return this._httpService.get<JsonHalCollection<InLineControlModel>>(url, undefined, httpParams, true);
    }
}
